<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span v-if="!item.levelListFirstHide">
          <span v-if="item.redirect==='noRedirect'||index==levelList.length-1" class="no-redirect">{{ item.meta.title }}</span>
          <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
        </span>
      </el-breadcrumb-item>
    </transition-group>
    
  </el-breadcrumb>
  
</template>

<script>
import pathToRegexp from 'path-to-regexp'

// import { getOrgInfo } from '@/api/api_url'
export default {
  
  data() {
    return {
      levelList: null,
      favorIconSrc:'',
      levelListFirstHide:false,           // 政企是没有首页，所以第一个隐藏
      orgData:''
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  mounted() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      const first = matched[0]

      if (!this.isDashboard(first)) {
        matched = [{ path: '/dashboard', meta: { title: '首页' }}].concat(matched)
      }

      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
      if(!this.orgData){
        this.orgData = JSON.parse(localStorage.getItem('orgType'))
        if(this.orgData && this.orgData.favor_icon){
          this.favorIconSrc = this.orgData.favor_icon
        }
      }
      let routesArr = []
      let sidebarStr = localStorage.getItem('sidebarList')
      if(sidebarStr){
        

        routesArr = JSON.parse(sidebarStr)
        console.log('面包屑',this.levelList)
        for(let i=0;i<this.levelList.length;i++){
          for(let j=0;j<routesArr.length;j++){
            if(this.levelList[i].redirect == routesArr[j].uri){
              this.levelList[i].meta.title = routesArr[j].title
              if(routesArr[j].nest_menu){
                for(let z=0;z<this.levelList.length;z++){
                  for(let x=0;x<routesArr[j].nest_menu.length;x++){
                    if(this.levelList[z].path == routesArr[j].nest_menu[x].uri){
                      this.levelList[z].meta.title = routesArr[j].nest_menu[x].title
                    }
                  }
                }
              }
              break
            }
          }
        
      }

        if(routesArr[0].uri != '/dashboard/dashboard'){    // 没有首页
          this.levelList[0].levelListFirstHide = true
        }
        if(this.$route.query.menu_type=='ratee'){
          this.levelList=[{
            path: '/evaluate/ratee',
            meta: {
              title: '/ 评教评学'
            }
          }]
        }
        if(this.$route.query.menu_type=='user_id'){
          this.levelList=[{
            path: '/evaluate/userid',
            meta: {
              title: '/ 我的数据'
            }
          }]
        }
      }
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    }
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
